import React from "react";

export type MessageFrameProps = {
  role: "user" | "assistant";
  statusLabel?: string;
  metaRight?: React.ReactNode;
  timestampMs?: number;
  children: React.ReactNode;
};

const formatTime = (ms: number): string => {
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    month: "numeric",
    day: "numeric",
    year: "2-digit",
    hour: "numeric",
    minute: "2-digit",
  });
};

export function MessageFrame({ role, statusLabel, metaRight, timestampMs, children }: MessageFrameProps) {
  const tsLabel = typeof timestampMs === "number" && timestampMs > 0 ? formatTime(timestampMs) : "";
  const trimmedStatusLabel = typeof statusLabel === "string" ? statusLabel.trim() : "";
  const align = role === "user" ? "ml-auto items-end" : "mr-auto items-start";

  return (
    <div className={`pm-msg-frame flex w-fit max-w-full flex-col ${align} gap-1`}>
      {children}
      {tsLabel || trimmedStatusLabel || metaRight ? (
        <div className="pm-msg-meta flex max-w-full items-center gap-2 px-2 text-[11px] text-muted-foreground">
          <div className="flex min-w-0 items-center gap-1">
            {trimmedStatusLabel ? (
              <>
                <span data-testid="pm-message-status-label">{trimmedStatusLabel}</span>
                {tsLabel ? <span aria-hidden="true">·</span> : null}
              </>
            ) : null}
            {tsLabel ? <span className="truncate">{tsLabel}</span> : null}
          </div>
          {metaRight ? <div className="shrink-0">{metaRight}</div> : null}
        </div>
      ) : null}
    </div>
  );
}
